import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractNotificationCardModel } from './abstract-notification-card.model';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-abstract-notification-card',
  styleUrls: ['./abstract-notification-card.component.scss'],
  templateUrl: './abstract-notification-card.component.html',
  imports: [NgClass, MatIcon, MatIconButton],
})
export class AbstractNotificationCardComponent {
  @Output() public closeEvent = new EventEmitter<void>();
  @Input() public notification: AbstractNotificationCardModel;
  @Input() public notificationIcon = 'alarm';

  public onCloseClickedHandler(): void {
    this.closeEvent.emit();
  }
}
